import axios, { Axios } from 'axios';

export class Service extends Axios {
  constructor(url: string) {
    const defaults = axios.create().defaults;
    super({
      ...defaults,
      baseURL: url,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
